import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#jobplacementDashboard",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Job Placement Dashboard")
  ])
], -1)
const _hoisted_3 = {
  id: "jobplacementDashboard",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Batch", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<h4 class=\"\">Certified Trainees</h4><div class=\"card p-3 position-relative\"><div class=\"row m-0\"><div class=\"col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4\"><div class=\"row\"><span class=\"svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3\"><i class=\"fas fa-user fs-3x text-success\"></i></span><h4 class=\"col mt-5\">2005</h4><a href=\"/assessor\" class=\"text-success fw-bold fs-6 mt-2\">Total Trainee</a></div></div><div class=\"col bg-light-danger d-flex align-items-center px-6 py-8 rounded-2 me-4\"><div class=\"row\"><span class=\"d-block my-2 col-md-3 mr-4\"><i class=\"fas fa-chalkboard-teacher fs-3x text-danger\"></i></span><h4 class=\"col mt-5\">1502</h4><a href=\"/trainer\" class=\"text-danger fw-bold fs-6 mt-2\">Trainee(s) Certified</a></div></div><div class=\"col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4\"><div class=\"row\"><span class=\"svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3\"><i class=\"fas fa-user-tie fs-3x text-success\"></i></span><h4 class=\"col mt-5\">868</h4><a href=\"/assessor\" class=\"text-success fw-bold fs-6 mt-2\">Total Job Placement</a></div></div><div class=\"col bg-light-info px-6 py-8 rounded-2\"><div class=\"row\"><span class=\"svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3\"><i class=\"fas fa-clock fs-3x text-info\"></i></span><h4 class=\"col mt-5\">215</h4><a href=\"/trainee\" class=\"text-info fw-bold fs-7 mt-2\">Certification Dues (&gt; 30)</a></div></div></div></div>", 2)
const _hoisted_24 = [
  _hoisted_22
]
const _hoisted_25 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Job Placement List", -1)
const _hoisted_27 = { class: "card mb-5 mb-xl-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_29 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-6" }
const _hoisted_32 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_PhotoModal = _resolveComponent("PhotoModal")!
  const _component_BankModal = _resolveComponent("BankModal")!
  const _component_LicenseModal = _resolveComponent("LicenseModal")!
  const _component_UserModal = _resolveComponent("UserModal")!
  const _component_EmployeeModal = _resolveComponent("EmployeeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(),
                _hoisted_9,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Association",
                  modelValue: _ctx.batch.entity_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: info.id,
                        label: info.entity_short_name,
                        value: info.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Institutes",
                  modelValue: _ctx.batch.training_institute,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.training_institute) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Augmedix Bangladesh",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Augmedix Bangladesh")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Genex Infosys Limited",
                      value: "2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Genex Infosys Limited")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Mars Solutions Limited",
                      value: "3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mars Solutions Limited")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Noble It Solution Ltd",
                      value: "4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Noble It Solution Ltd")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Digicon Technologies Ltd.",
                      value: "4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Digicon Technologies Ltd.")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Service Solutions Pvt. Ltd.",
                      value: "4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Service Solutions Pvt. Ltd.")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.batch.tranche_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Tranche-1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tranche-1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Tranche-2",
                      value: "2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tranche-2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Tranche-3",
                      value: "3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tranche-3")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Tranche-4",
                      value: "4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tranche-4")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Course",
                  modelValue: _ctx.batch.course,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "BACCO-MS | Medical Scribing | 2 | 160 | 31519",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("BACCO-MS | Medical Scribing | 2 | 160 | 31519")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.batch.batch,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.batch) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseNotice()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "1",
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "2",
                      value: "2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "3",
                      value: "3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("3")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "4",
                      value: "4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("4")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            ((_ctx.showCourseNotice == true) & (_ctx.batch.tranche_id != 4))
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
              : _createCommentVNode("", true),
            (_ctx.showCourseNotice == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.tableData,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-sl": _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.id), 1)
                              ]),
                              "cell-name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.name), 1)
                              ]),
                              "cell-photo": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.photo), 1)
                              ]),
                              "cell-ref_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.ref_no), 1)
                              ]),
                              "cell-reg_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.reg_no), 1)
                              ]),
                              "cell-employee_status": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.employee_status), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_PhotoModal),
    _createVNode(_component_BankModal),
    _createVNode(_component_LicenseModal),
    _createVNode(_component_UserModal),
    _createVNode(_component_EmployeeModal)
  ], 64))
}